var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveListLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    transform: "translate(0 0.5)",
    fill: "#1B51BB",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 39,
    height: 39,
    rx: 3.5,
    stroke: "#1B51BB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.25 15.25C10.25 14.4216 10.9216 13.75 11.75 13.75C12.5784 13.75 13.25 14.4216 13.25 15.25C13.25 16.0784 12.5784 16.75 11.75 16.75C10.9216 16.75 10.25 16.0784 10.25 15.25ZM14.75 15.25C14.75 14.8358 15.0858 14.5 15.5 14.5H29C29.4142 14.5 29.75 14.8358 29.75 15.25C29.75 15.6642 29.4142 16 29 16H15.5C15.0858 16 14.75 15.6642 14.75 15.25ZM10.25 20.5C10.25 19.6716 10.9216 19 11.75 19C12.5784 19 13.25 19.6716 13.25 20.5C13.25 21.3284 12.5784 22 11.75 22C10.9216 22 10.25 21.3284 10.25 20.5ZM14.75 20.5C14.75 20.0858 15.0858 19.75 15.5 19.75H29C29.4142 19.75 29.75 20.0858 29.75 20.5C29.75 20.9142 29.4142 21.25 29 21.25H15.5C15.0858 21.25 14.75 20.9142 14.75 20.5ZM10.25 25.75C10.25 24.9216 10.9216 24.25 11.75 24.25C12.5784 24.25 13.25 24.9216 13.25 25.75C13.25 26.5784 12.5784 27.25 11.75 27.25C10.9216 27.25 10.25 26.5784 10.25 25.75ZM14.75 25.75C14.75 25.3358 15.0858 25 15.5 25H29C29.4142 25 29.75 25.3358 29.75 25.75C29.75 26.1642 29.4142 26.5 29 26.5H15.5C15.0858 26.5 14.75 26.1642 14.75 25.75Z",
    fill: "#1B51BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveListLogo);
export default __webpack_public_path__ + "static/media/ActiveListLogo.61186c81782b89e6f57a89dafc81a3ea.svg";
export { ForwardRef as ReactComponent };